export enum COLORS {
  YELLOW = '#FFCC00',
  BLACK = '#000000',
  HOVER_BLACK = '#373737',
  TOOLTIP_BLACK = '#1A1A1A',
  WHITE = '#FFFFFF',
  ERROR_RED = '#FF4D4D',
  AQUA_BLUE = '#4389F3',
  LIGHT_GRAY = '#E5E5E5',
  OPAQUE_GRAY = '#BCBCBC',
  BORDER_GRAY = '#B3B3B3',
  HOVER_GRAY = '#F0F0F0',
  TEXT_GRAY = '#686868',
  CONTENT_GRAY = '#F7F7F7',
  DARK_GRAY = '#C6C6C6',
  GREEN = '#33B612'
}
